import React, { FunctionComponent, useState } from "react";
import styles from "./styles.module.scss";
import { Box, Card, CardActionArea, Chip, ListItem, Stack, useTheme } from "@mui/material";
import classNames from "classnames";
import { IProduct } from "../../../hooks/products";
import { strings } from "../../../localization/LocalizedStrings";
import { useCurrencyFormatter } from "../../../hooks/currencyFormatter";
import { useUserProfile } from "../../../hooks/session";
import { DiscountTag } from "../../DiscountTag";
import { ProductPurchaseDialog } from "../ProductPurchaseDialog";
import { productIconMap } from "../../../models/ProductUtilities";
import { Icon, IconType } from "../../../icons";
import { ProductType } from "../../../hooks/products/interfaces";

export const ProductPurchaseItem: FunctionComponent<IProductPurchaseItemProps> = ({
  product,
  productType
}) => {
  const theme = useTheme();
  const currencyFormatter = useCurrencyFormatter();
  const [currentUserProfile] = useUserProfile.useState();
  const [isPurchaseDialogOpen, setIsPurchaseDialogOpen] = useState(false);
  return (
    <ListItem className={styles.item}>
      <Card className={styles.container} elevation={5}>
        <Stack direction={"row"} sx={{ width: "100%" }}>
          <CardActionArea
            className={classNames(styles.actionArea, styles.positionContainer)}
            onClick={() => setIsPurchaseDialogOpen(true)}
          >
            <div
              className={styles.severityMark}
              style={{ backgroundColor: theme.palette.colors.highlightBorder }}
            />
            <Stack sx={{ width: "100%", alignItems: "center" }} direction={"row"} spacing={2}>
              <Icon
                type={product.type == "bundle" ? IconType.LocalMall : productIconMap[productType]}
              />
              <Stack sx={{ width: "100%" }} spacing={1}>
                <Stack direction={"row"}>
                  <p className={styles.name}>{product.name}</p>
                  {product.discountARS > 0 && (
                    <DiscountTag className={styles.discountBox} percentage={product.discountARS} />
                  )}
                </Stack>
                <p className={classNames(styles.description, styles.description)}>
                  {product.description}
                </p>
              </Stack>
              <Box flexGrow={1} />
              <div className={styles.price}>
                {product.priceARS > 0 && (
                  <div>
                    {product.discountARS > 0 && (
                      <p
                        className={styles.oldPrice}
                        style={{ color: theme.palette.secondary.main }}
                      >
                        {currencyFormatter.format(
                          strings.currencyLocale == "es-AR" ? product.priceARS : product.priceUSD,
                          currentUserProfile,
                          false,
                          2,
                          strings.currencyLocale == "es-AR" ? "ARS" : "USD",
                          strings.currencyLocale !== "es-AR"
                        )}
                      </p>
                    )}
                    <Chip
                      className={styles.newPrice}
                      variant={"outlined"}
                      label={currencyFormatter.format(
                        strings.currencyLocale == "es-AR"
                          ? product.finalPriceARS
                          : product.finalPriceUSD,
                        currentUserProfile,
                        false,
                        2,
                        strings.currencyLocale == "es-AR" ? "ARS" : "USD",
                        strings.currencyLocale !== "es-AR"
                      )}
                    />
                  </div>
                )}
              </div>
            </Stack>
          </CardActionArea>
        </Stack>
      </Card>
      <ProductPurchaseDialog
        product={product}
        isOpen={isPurchaseDialogOpen}
        setIsOpen={setIsPurchaseDialogOpen}
      />
    </ListItem>
  );
};

export interface IProductPurchaseItemProps {
  product: IProduct;
  productType: ProductType;
}
